// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"b9b2a659","117":"3c526cc9","204":"7033f010","331":"415ac3c9","332":"882f1d12","782":"cb5207f3","858":"2b02aa7e","865":"ebe9a957","971":"b3e0ad4f"}[chunkId] + ".chunk.css";
};